import { Lightning, Sparkle, Users, CurrencyCircleDollar, Bell } from '@phosphor-icons/react';

const TEMPLATE_ICONS = {
  morning_briefing: { icon: Sparkle, color: 'text-[#f59e0b]', bg: 'bg-[#fef3c7]' },
  team_task_manager: { icon: Users, color: 'text-[#7c3aed]', bg: 'bg-[#ede9fe]' },
  subscription_optimizer: { icon: CurrencyCircleDollar, color: 'text-[#0ea5e9]', bg: 'bg-[#e0f2fe]' },
  bill_reminder: { icon: Bell, color: 'text-[#ef4444]', bg: 'bg-[#fee2e2]' },
};

export const TemplateSelector = ({ templates, onSelect, onCustom }) => (
  <div className="space-y-4" data-testid="template-selector">
    <p className="text-xs text-[#596065]">Start from a template or build your own routine from scratch.</p>

    <div className="grid sm:grid-cols-2 gap-3">
      {templates.map((t) => {
        const iconConfig = TEMPLATE_ICONS[t.template_id] || { icon: Lightning, color: 'text-[#596065]', bg: 'bg-[#f2f4f6]' };
        const Icon = iconConfig.icon;
        return (
          <button
            key={t.template_id}
            onClick={() => onSelect(t.template_id)}
            className="text-left p-4 rounded-xl border border-[#f0f1f3] hover:border-[#d0e4f7] hover:bg-[#fafbfc] transition-all"
            data-testid={`template-${t.template_id}`}
          >
            <div className="flex items-center gap-2.5 mb-2">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${iconConfig.bg}`}>
                <Icon size={16} className={iconConfig.color} weight="fill" />
              </div>
              <div>
                <p className="font-bold text-sm text-[#2d3338]">{t.name}</p>
                <p className="text-[10px] text-[#acb3b8]">{t.action_count} steps</p>
              </div>
            </div>
            <p className="text-xs text-[#596065] line-clamp-2">{t.description}</p>
          </button>
        );
      })}
    </div>

    <button
      onClick={onCustom}
      className="w-full p-3 rounded-xl border-2 border-dashed border-[#d0e4f7] text-[#005bc1] text-xs font-semibold hover:bg-[#f0f7ff] transition-colors"
      data-testid="custom-agent-btn"
    >
      + Build Custom Agent
    </button>
  </div>
);
